/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { Mousetrap } from '../../common';

import './Button.scss';

interface ButtonProps {
    children?: string;
    highlighted?: boolean;
}

const Button: FunctionComponent<ButtonProps> = ({ children, highlighted }): JSX.Element => {
    const btnClasses = `btn${(highlighted && ' highlighted') || ''}`;
    return (
        <React.Fragment>
            <Mousetrap value={highlighted}>
                <div className={btnClasses}>
                    <span className="btn-label">{children}</span>
                </div>
            </Mousetrap>
        </React.Fragment>
    );
};

Button.propTypes = {
    children: PropTypes.string,
    highlighted: PropTypes.bool,
};

export default Button;
